import type { FlagValue } from '@openfeature/core';
import { FeatureFlag } from './types/featureFlagTypes';

export function findFeatureFlagValue(featuresObj: FeatureFlag, key: string): FlagValue | null {
  const flagValue = null;
  const evaluatedFlagValues = featuresObj?.evaluatedFlags || {};
  if (key in evaluatedFlagValues) {
    return evaluatedFlagValues[key];
  }
  return flagValue;
}

export function findFeatureVisibility(featuresObj: FeatureFlag, key: string): boolean {
  const evaluatedFlagValues = featuresObj?.evaluatedFlags || {};
  return key in evaluatedFlagValues && !!evaluatedFlagValues[key];
}
